import { mutatorAction } from "satcheljs";
import { ShiftsByMemberAndDateStore } from "sh-conflict-store";

export default mutatorAction('RESET_SHIFTID_TO_MEMBERDATEID_MAP', function resetShiftIdInMemberDateIdsMap(shiftId: string) {
   if (ShiftsByMemberAndDateStore().shiftIdToMemberDateIdsMap.has(shiftId)) {
      ShiftsByMemberAndDateStore().shiftIdToMemberDateIdsMap.delete(shiftId);
   }
});
